import { ColumnEditorOptions } from "primereact/column";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useState } from "react";
import { QuestionOption } from "../../../types/checklist";

interface SingleChoiceEditorProps {
    options: ColumnEditorOptions;
    questionOptions: QuestionOption[];
    onCommit?: (value: unknown) => void;
}

export const SingleChoiceEditor = ({ options, questionOptions, onCommit }: SingleChoiceEditorProps) => {
    // Seed once so the current option shows on open and survives re-renders.
    const [value, setValue] = useState(() => options.value);

    const handleChange = (e: DropdownChangeEvent) => {
        setValue(e.value);
        options.editorCallback?.(e.value);
        // A pick saves on selection rather than waiting for the cell to blur.
        onCommit?.(e.value);
    };

    const dropdownOptions = questionOptions.map((opt) => ({
        label: opt.text,
        value: opt.id,
    }));

    return (
        <Dropdown
            value={value}
            options={dropdownOptions}
            onChange={handleChange}
            placeholder="Select an option"
            className="w-full"
            autoFocus
        />
    );
};

export const singleChoiceDisplayTemplate = (value: unknown, questionOptions?: QuestionOption[]): string => {
    if (!value) return "";
    if (!questionOptions) return String(value);

    const option = questionOptions.find((opt) => opt.id === value);
    return option?.text ?? String(value);
};
